import { styled, Button } from "@mui/material";
import React from 'react'



const LinkButton = ({color= "var(--gray-2)", underline = "underline" , children , ...props}) => {
  const LinkButton = styled(Button)(({ theme }) => ({
    fontSize: 14,
    color: color,
    textTransform: "none",
    textDecoration: underline,
  }));
  return (
    <LinkButton {...props}>{children}</LinkButton>
  )
}



export default LinkButton;
